import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import { Dialog } from "@progress/kendo-react-dialogs";
import { Switch } from "@progress/kendo-react-inputs";
import ErrorHelper from "../../helper/error-helper";
import { NotificationManager } from "src/util/notify";
import InputKendoRct from "../../control-components/input/input";
import Loader from "../../control-components/loader/loader";
import NOTIFICATION_MESSAGE from "../../helper/notification-messages";
import DropDownKendoRct from "../../control-components/drop-down/drop-down";
import { RegionsService } from "../../services/regionsService";
import { ClinicDomainService } from "../../services/clinicDomainService";

function AddClinicDomain({ onClose }) {
  
 

  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState("");
  const [settingError, setSettingError] = useState(false);
  const [regionListing, setRegions] = useState([]);
  const [showOtp, setShowOtp] = useState("password");

  let [fields, setFields] = useState({
    regionName: "",
    clinicDomainName: "",
    dbSource: "",
    dbName: "",
    dbUser: "",
    dbPassword: "",
    isDefault: false,
  });

  useEffect(() => {
    getAllRegions();
  }, []);

  const handleValidation = () => {
    let errors = {};
    let formIsValid = true;

    if (!fields.regionName) {
      formIsValid = false;
      errors["regionName"] = ErrorHelper.FIELD_BLANK;
    }
    if (
      !fields.clinicDomainName ||
      fields.clinicDomainName.trim().length === 0
    ) {
      formIsValid = false;
      errors["clinicDomainName"] = ErrorHelper.FIELD_BLANK;
    }

    if (!fields.dbSource || fields.dbSource.trim().length === 0) {
      formIsValid = false;
      errors["dbSource"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.dbName || fields.dbName.trim().length === 0) {
      formIsValid = false;
      errors["dbName"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.dbUser || fields.dbUser.trim().length === 0) {
      formIsValid = false;
      errors["dbUser"] = ErrorHelper.FIELD_BLANK;
    }
    if (!fields.dbPassword || fields.dbPassword.trim().length === 0) {
      formIsValid = false;
      errors["dbPassword"] = ErrorHelper.FIELD_BLANK;
    }

    setErrors(errors);
    return formIsValid;
  };

  const handleChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setFields({
      ...fields,
      [name]: value,
    });
  };

  const handleSubmit = (event) => {
    setSettingError(true);
    if (handleValidation()) {
      addClinicDomain();
    }
  };

  const getAllRegions = async () => {
    await RegionsService.getRegions()
      .then((result) => {
        setRegions(result.resultData);
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const addClinicDomain = async () => {
    setLoading(true);
    await ClinicDomainService.insertClinicDomain(fields)
      .then((result) => {
        setLoading(false);
        NotificationManager.success(NOTIFICATION_MESSAGE.CLINIC_DOMAIN_ADDED);
        onClose({ updated: true });
      })
      .catch((error) => {
        setLoading(false);
        NotificationManager.error(error);
      });
  };

  const handleShowOtp = () => {
    setShowOtp(showOtp === "password" ? "text" : "password");
  };

  return (
    <Dialog
      onClose={onClose}
      title={"Add Clinic Domain"}
      className="small-dailog"
    >
      <div className="edit-Service-popup dialog-edit py-3">
        <div className="mx-3">
          <div className="row align-items-center">
            <div className="col-12 mb-3">
              <DropDownKendoRct
                label="Region Name"
                value={fields.regionName}
                onChange={handleChange}
                data={regionListing}
                textField="regionName"
                suggest={true}
                name="regionName"
                dataItemKey="id"
                required={true}
                validityStyles={settingError}
                error={!fields.regionName && errors.regionName}
                className="form-control"
                placeholder="Region Name"
              />
            </div>
            <div className="col-12 mb-3">
              <InputKendoRct
                value={fields.clinicDomainName}
                onChange={handleChange}
                name="clinicDomainName"
                label="Clinic Name"
                error={fields.clinicDomainName === "" && errors.clinicDomainName}
                validityStyles={settingError}
                required={true}
                className="form-control"
                placeholder={"Clinic Name"}
              />
            </div>

            <div className="col-12 mb-3">
              <InputKendoRct
                value={fields.dbSource}
                onChange={handleChange}
                name="dbSource"
                label="Source"
                error={fields.dbSource === "" && errors.dbSource}
                validityStyles={settingError}
                required={true}
                className="form-control"
                placeholder={"Source"}
              />
            </div>

            <div className="col-12 mb-3">
              <InputKendoRct
                value={fields.dbName}
                onChange={handleChange}
                name="dbName"
                label="Domain Name"
                error={fields.dbName === "" && errors.dbName}
                validityStyles={settingError}
                required={true}
                className="form-control"
                placeholder={"Domain Name"}
              />
            </div>

            <div className="col-12 mb-3">
              <InputKendoRct
                value={fields.dbUser}
                onChange={handleChange}
                name="dbUser"
                label="DB User"
                error={fields.dbUser === "" && errors.dbUser}
                validityStyles={settingError}
                required={true}
                className="form-control"
                placeholder={"DB User"}
              />
            </div>

            <div className="col-12 mb-3 position-relative">
              <InputKendoRct
                name="dbPassword"
                value={fields.dbPassword}
                onChange={handleChange}
                label="Password"
                error={fields.dbPassword === "" && errors.dbPassword}
                validityStyles={settingError}
                required={true}
                className="form-control"
                type={showOtp}
              />
              <div onClick={handleShowOtp} className="cursor-pointer eye-close">
                {showOtp !== "password" ? (
                  <i class="far fa-eye text-theme"></i>
                ) : (
                  <i class="far fa-eye-slash"></i>
                )}
              </div>
            </div>
            <div className="col-12 ">
              <ul className="d-flex flex-wrap list-unstyled mb-0 ">
                <li className="col-md-6 col-12   switch-on">
                  <Switch
                    onChange={handleChange}
                    onLabel={"on"}
                    offLabel={"off"}
                    name="isDefault"
                    value={fields.isDefault}
                  />

                  <span className="switch-title-text ml-2  fw-500 f-16 ">
                    Default
                  </span>
                </li>
              </ul>
            </div>
          </div>
        </div>
        {loading === true && <Loader />}
      </div>

      <div className="border-bottom-line"></div>
      <div className="d-flex my-4">
        <button
          className="btn green-btn btn-primary btn-space  text-white border-0 mx-3"
          onClick={handleSubmit}
        >
          Add
        </button>

        <button className="btn grey-secondary btn-space " onClick={onClose}>
          Cancel
        </button>
      </div>
    </Dialog>
  );
}
export default AddClinicDomain;
